import { wtClientApi } from 'api/clients';

import type { GenericResponse } from 'commons/modules/generic-response';

import {
  ApiResponse,
  adaptApiToGenericResponse,
  adaptErrorToGenericResponse,
} from '../shared';

export const getAccounts = async (params: {
  accountNumber: string;
}): Promise<GenericResponse<ApiResponse<string[]>>> => {
  try {
    const response = await wtClientApi.get<ApiResponse<string[]>>(
      '/management/investment/only-accounts',
      { params: { accountNumber: params.accountNumber } },
    );

    return adaptApiToGenericResponse(response.data, response.status);
  } catch (error: any) {
    return adaptErrorToGenericResponse(
      error,
      'Ocurrió un error al obtener datos de cuentas',
    );
  }
};
